import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdCallEnd } from 'react-icons/md';

const HangUp: React.FC<IconBaseProps> = (props) => <MdCallEnd {...props} />;

export default HangUp;
